import axios from "axios";
import "regenerator-runtime/runtime";
axios.defaults.withCredentials = true;
//"https://amystorewebapp.herokuapp.com/api"
const url =
  process.env.PRODUCTION === false
    ? "http://localhost:8080/api"
    : process.env.BACKEND_URL;

export const sendMessage = (messageFormData) =>
  axios.post(`${url}/sendMessage`, messageFormData);

export const setAnnouncement = (messageFormData) =>
  axios.post(`${url}/setAnnouncement`, messageFormData);
export const newProduct = (data) => axios.post(`${url}/newProduct`, data);
export const addToCart = (data) => axios.post(`${url}/addToCart`, data);
export const newDish = (dishData) => axios.post(`${url}/newDish`, dishData);
export const checkoutSession = (data) =>
  axios.post(`${url}/checkoutSession`, data);
export const getRequests = () => axios.get(`${url}/getRequests`);
export const fetchAllUser = () => axios.get(`${url}/fetchAllUser`);
export const getSingleProduct = (id) =>
  axios.get(`${url}/getSingleProduct/${id}`);
export const getSession = () => axios.get(`${url}/getSession`);
export const getConversation = (data) =>
  axios.post(`${url}/getConversation`, data);
export const authenticated = () => axios.get(`${url}/authenticated`);
export const getUser = () => axios.get(`${url}/getUser`);
export const getBillingDetails = () => axios.get(`${url}/getBillingDetails`);
export const getProducts = () => axios.get(`${url}/getProducts`);
export const getOrderDetail = (id) =>
  axios.get(`${url}/getOrderDetail/orderId/${id}`);
export const getAnnouncement = (userId) =>
  axios.get(`${url}/getAnnouncement/${userId}`);
export const viewCustomerOrder = (data) =>
  axios.post(`${url}/customer/orderData`, data);
export const getCartItem = () => axios.get(`${url}/getCartItem`);
export const deleteProduct = (data) =>
  axios.delete(`${url}/deleteProduct`, data);
export const setStatus = (data) => axios.put(`${url}/setStatus`, data);
export const editProfile = (data) => axios.put(`${url}/editProfile`, data);
export const addToCheckouts = (data) =>
  axios.put(`${url}/addToCheckouts`, data);
export const updateTotalProduct = (data) =>
  axios.put(`${url}/updateTotalProduct`, data);
export const setDishTimeServe = (data) =>
  axios.put(`${url}/setDishTimeServe`, data);

export const setNewEditedProduct = (data) =>
  axios.put(`${url}/setNewEditedProduct`, data);
export const setBillingDetails = (data) =>
  axios.put(`${url}/setBillingDetails`, data);
export const deleteToCart = (data) => axios.put(`${url}/deleteToCart`, data);
export const setProductStatus = (data) =>
  axios.put(`${url}/setProductStatus`, data);
export const editCart = (data) => axios.put(`${url}/editCart`, data);
export const statusCount = () => axios.get(`${url}/statusCount`);
export const getBagOfOrder = () => axios.get(`${url}/getBagOfOrder`);
export const getCartCountAndBag = () => axios.get(`${url}/getCartCountAndBag`);
export const checkIfAdmin = () => axios.get(`${url}/checkIfAdmin`);
export const signIn = (formData) => axios.post(`${url}/signin`, formData);
export const searchProduct = (data) => axios.post(`${url}/searchProduct`, data);
export const extendSession = (sessionTime) =>
  axios.post(`${url}/extend`, sessionTime);
export const logout = (data) => axios.post(`${url}/logout`, data);
//darundaywebprofile.herokuapp.com

//chat api
export const addMessage = (chatData) =>
  axios.post(`${url}/addMessage`, chatData);
export const getMessages = (data) => axios.post(`${url}/getMessages`, data);
export const setUnreadMessage = (data) =>
  axios.put(`${url}/setUnreadMessage`, data);
export const notifyRead = (data) => axios.put(`${url}/notifyRead`, data);
